import { h, render } from 'preact';
import { useProduct } from './product-context';

import './rebuy-pair-it-with.css';

const RebuyPairItWith = () => {
  const { activeProduct } = useProduct();
  const activeProductId = activeProduct?.id.split('gid://shopify/Product/')[1];
  return (
    <div
      data-rebuy-id="167325"
      data-rebuy-shopify-product-ids={activeProductId}
    />
  );
};

export default RebuyPairItWith;
